export class TableRow {
    public isSelected: boolean;
    public isSelectionFreezed: boolean;
    public isEdited: boolean;
    public isNewRow: boolean;
    public cells: {};
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/models/table-row.model.ts